import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  confirmed: true,
  content_buyer_id: null,
  inquirer_key: null,
  inquirer_value: null,
  has_note: null,
  duplicates: null,
  unreachable_submitter: null,
  month: null,
  year: null,
  submit_place: null,
  from: null,
  to: null,
  apiActiveTwo: true,
};

const dashboardPurchaseWebsiteSlice = createSlice({
  name: "dashboardPurchaseWebsiteSlice",
  initialState,
  reducers: {
    setConfirmed: (state, action) => {
      state.confirmed = action.payload;
    },
    setContentBuyerId: (state, action) => {
      state.content_buyer_id = action.payload;
    },
    setInquirerKey: (state, action) => {
      state.inquirer_key = action.payload;
    },
    setInquirerValue: (state, action) => {
      state.inquirer_value = action.payload;
    },
    setHasNote: (state, action) => {
      state.has_note = action.payload;
    },
    setDuplicates: (state, action) => {
      state.duplicates = action.payload;
    },
    setUnreachableSubmitter: (state, action) => {
      state.unreachable_submitter = action.payload;
    },
    setMonth: (state, action) => {
      state.month = action.payload;
    },
    setYear: (state, action) => {
      state.year = action.payload;
    },
    setSubmitPlace: (state, action) => {
      state.submit_place = action.payload;
    },
    setFrom: (state, action) => {
      state.from = action.payload;
    },
    setTo: (state, action) => {
      state.to = action.payload;
    },
    setApiActiveTwo: (state, action) => {
      state.apiActiveTwo = action.payload;
    },
  },
});

export const {
  setConfirmed,
  setContentBuyerId,
  setInquirerKey,
  setInquirerValue,
  setHasNote,
  setDuplicates,
  setUnreachableSubmitter,
  setMonth,
  setYear,
  setSubmitPlace,
  setFrom,
  setTo,
  setApiActiveTwo,
} = dashboardPurchaseWebsiteSlice.actions;

export default dashboardPurchaseWebsiteSlice.reducer;
